
export interface PortfolioPosition {
  assetId: string;
  quantity: number;
  price?: number;
  value?: number;
  sourceId: string;
}

export interface CryptoPrice {
  symbol: string;
  priceUsd: number;
  marketCapRank?: number;
}

const SYMBOL_MAP: Record<string, string> = {
  XBT: "BTC",
  BUSD: "USDT",
  'BSC-USD': 'USDC'
};

export class ValuationEngine {
  private priceCache: Map<string, number> = new Map();

  constructor(private cryptoTable: CryptoPrice[]) {
    cryptoTable.forEach(c => {
      if (c.symbol && typeof c.symbol === 'string' && typeof c.priceUsd === 'number' && !Number.isNaN(c.priceUsd)) {
        const normalizedSymbol = c.symbol.toUpperCase();
        const existingPrice = this.priceCache.get(normalizedSymbol);
        const shouldReplace = existingPrice === undefined
          || existingPrice <= 0
          || c.priceUsd > 0;
        if (shouldReplace) {
          this.priceCache.set(normalizedSymbol, c.priceUsd);
        }
      }
    });
  }

      getPrice(symbol: string): number {
      const mappedSymbol = this.mapSymbol(symbol).toUpperCase();
      return this.priceCache.get(mappedSymbol) ?? 0;
    }

  apply(portfolio: PortfolioPosition[]): PortfolioPosition[] {
    return portfolio.map(pos => {
      const mappedSymbol = this.mapSymbol(pos.assetId).toUpperCase();
      const price = this.priceCache.get(mappedSymbol) ?? 0;
      if (
        pos.assetId === 'USDT' &&
        typeof (pos as any).sourceType === 'string' &&
        (pos as any).sourceType === 'MANUAL'
      ) {
        console.log('[ValuationEngine][MANUAL][USDT] price set:', price, 'quantity:', pos.quantity);
      }
      return {
        ...pos,
        price,
        value: pos.quantity * price
      };
    });
  }

  updatePrice(symbol: string, priceUsd: number) {
    this.priceCache.set(symbol, priceUsd);
  }

  mapSymbol(symbol: string): string {
    return SYMBOL_MAP[symbol] ?? symbol;
  }

  totalValue(portfolio: PortfolioPosition[]): number {
    return portfolio.reduce((sum, pos) => sum + (pos.value ?? 0), 0);
  }

  allocation(portfolio: PortfolioPosition[]): Record<string, number> {
    const total = this.totalValue(portfolio);
    const alloc: Record<string, number> = {};
    portfolio.forEach(pos => {
      alloc[pos.assetId] = total > 0 ? (pos.value ?? 0) / total : 0;
    });
    return alloc;
  }
}
